import { render, staticRenderFns } from "./centerExamine.vue?vue&type=template&id=8e3448cc&scoped=true&"
import script from "./centerExamine.vue?vue&type=script&lang=js&"
export * from "./centerExamine.vue?vue&type=script&lang=js&"
import style0 from "./centerExamine.vue?vue&type=style&index=0&id=8e3448cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3448cc",
  null
  
)

export default component.exports